/**
 * Centralized access to Vite env vars. Avoids `import.meta.env` scattered
 * across the codebase and gives us one place to validate / default.
 */

const raw = import.meta.env;

function bool(v: string | undefined, fallback: boolean): boolean {
  if (v === undefined || v === '') return fallback;
  return v === '1' || v.toLowerCase() === 'true';
}

export const env = {
  apiBaseUrl: (raw.VITE_API_BASE_URL ?? 'http://localhost:3000').replace(/\/$/, ''),
  apiKey: raw.VITE_API_KEY ?? '',
  isDev: raw.DEV === true,
  isProd: raw.PROD === true,
  /**
   * Whether to enforce MFA enrollment for admin-tier users.
   * Default OFF — set `VITE_REQUIRE_MFA=true` in production / staging.
   * Dev and UAT typically leave unset for fast iteration.
   */
  requireMfa: bool(raw.VITE_REQUIRE_MFA, false),
  /**
   * Whether to enforce re-acceptance of stale Terms / Privacy / DPA versions.
   * Default OFF — set `VITE_REQUIRE_CONSENT_GATE=true` in production / staging.
   */
  requireConsentGate: bool(raw.VITE_REQUIRE_CONSENT_GATE, false),
};
